(function(scope){
 'use strict';
 const states = ['queued','processing','review','failed'];
 const wait = (ms, signal) => new Promise((resolve,reject) => {
  const abort=()=>{clearTimeout(timer);reject(new DOMException('Cancelled','AbortError'));};
  const timer=setTimeout(()=>{signal.removeEventListener('abort',abort);resolve();},ms);
  signal.addEventListener('abort',abort,{once:true});if(signal.aborted)abort();
 });
 class RefineArtworkConverter {
  constructor({endpoint,purpose,fetcher=scope.fetch.bind(scope),onChange=()=>{},pause=wait,pollMs=2500}) {
   this.endpoint=endpoint.replace(/\/$/,'');this.purpose=purpose;this.fetcher=fetcher;this.onChange=onChange;this.pause=pause;this.pollMs=pollMs;this.entries=new Map();
  }
  get(key){return this.entries.get(key);}
  clear(key){const entry=this.get(key);if(entry){entry.abort?.abort();if(entry.preview)URL.revokeObjectURL(entry.preview);}this.entries.delete(key);}
  select(key,file,mode='logo'){this.clear(key);this.entries.set(key,{file,mode,state:'idle'});}
  useStaffReview(key){const old=this.get(key);if(old){this.select(key,old.file,old.mode);this.get(key).state='manual';this.onChange(key);}}
  setMode(key,mode){const old=this.get(key);if(old&&old.mode!==mode)this.select(key,old.file,mode);}
  busy(key){return ['verifying','uploading','queued','processing','downloading'].includes(this.get(key)?.state);}
  async request(entry,path,options={}){
   const response=await this.fetcher(this.endpoint+path,{...options,headers:{...options.headers,Authorization:'Bearer '+entry.job.token},signal:entry.abort.signal,credentials:'omit',cache:'no-store'});
   if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.message||'The preview could not load. Try again, or continue with staff review.');}
   return response;
  }
  async start(key,challenge){
   const entry=this.get(key);if(!entry||this.busy(key)||entry.state==='review')return;
   entry.abort=new AbortController();
   const update=(state,message='')=>{if(this.get(key)!==entry)return;entry.state=state;entry.message=message;this.onChange(key);};
   try{
    if(!entry.job){
     const bytes=crypto.getRandomValues(new Uint8Array(32));
     entry.job={id:crypto.randomUUID(),token:Array.from(bytes,n=>n.toString(16).padStart(2,'0')).join('')};
    }
    const path='/v1/jobs/'+entry.job.id;
    if(!entry.submitted){
     update('verifying');const token=await challenge(entry.abort.signal);
     if(entry.abort.signal.aborted||this.get(key)!==entry)return;
     update('uploading');
     const bytes=new Uint8Array(await entry.file.arrayBuffer());let binary='';
     for(let i=0;i<bytes.length;i+=32768)binary+=String.fromCharCode(...bytes.subarray(i,i+32768));
     const response=await this.request(entry,path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({extension:entry.file.name.split('.').pop().toLowerCase(),mode:entry.mode,purpose:this.purpose,image:btoa(binary),challenge:token})});
     entry.submitted=true;entry.remote=await response.json();
    }
    const deadline=Date.now()+300000;
    while(true){
     if(this.get(key)!==entry||entry.abort.signal.aborted)return;
     const result=entry.remote||await (await this.request(entry,path)).json();entry.remote=null;
     if(!states.includes(result.state))throw new Error('Unexpected preview response. Please use staff review.');
     if(result.state==='failed'){if(this.purpose==='corporate')entry.failedConversion=true;else{entry.job=null;entry.submitted=false;}throw new Error(result.message||'Our team will need to prepare this artwork.');}
     if(result.state==='review'){
      update('downloading');
      const blobs=await Promise.all(['preview','master','jpg'].map(async name=>{
       const blob=await (await this.request(entry,path+'/'+name)).blob();
       if(blob.size>10*1024*1024||blob.type!==(name==='jpg'?'image/jpeg':'image/png'))throw new Error('The preview file could not be verified. Please use staff review.');
       return blob;
      }));
      if(this.get(key)!==entry||entry.abort.signal.aborted)return;
      entry.preview=URL.createObjectURL(blobs[0]);
      entry.master=new File([blobs[1]],'engraving-proof-'+key.toLowerCase()+'.png',{type:'image/png'});
      entry.jpg=new File([blobs[2]],'engraving-proof-'+key.toLowerCase()+'.jpg',{type:'image/jpeg'});
      entry.metadata=result.metadata;update('review');return;
     }
     update(result.state);
     if(Date.now()>deadline)throw new Error('Your preview is taking longer than usual. Choose Resume preview to check it, or continue with staff review.');
     await this.pause(this.pollMs,entry.abort.signal);
    }
   }catch(error){if(error.name!=='AbortError'&&this.get(key)===entry)update('error',error.message);}
  }
 }
 scope.RefineArtworkConverter=RefineArtworkConverter;
 if(typeof module!=='undefined')module.exports=RefineArtworkConverter;
})(typeof window!=='undefined'?window:globalThis);
